<template>
  <v-content>
    <v-container
      fluid
      style="display: flex; flex-direction: column; height: calc(100vh - 100px)"
    >
      <h1 class="py-3">
        <v-btn small fab color="secondary" :to="{ path: '/assetinfos' }"
          ><v-icon>reply</v-icon></v-btn
        >
        <span v-if="asset" class="titleText pl-2"
          >Asset Info - {{ asset.co_assetid }}</span
        >
        <span v-else class="titleText pl-2">Asset</span>
        <v-btn depressed @click="showModal()">
          <v-icon right>edit</v-icon>
          <span>Edit</span>
        </v-btn>
        <v-btn depressed @click="loadAssets()">
          <v-icon right>replay</v-icon>
          <span>Refresh</span>
        </v-btn>
      </h1>
      <v-alert v-if="error" :value="true" type="error">
        {{ error }}
      </v-alert>
      <div id="DetailedInfo" style="display: flex; gap: 5em; padding: 15px 0">
        <div id="asset" style="display: inline-block">
          <template v-if="asset">
            <h4>Asset Information</h4>
            Asset ID: <strong>{{ asset.co_assetid }}</strong
            ><br />
            Asset Description: <strong>{{ asset.co_description }}</strong
            ><br />
            Asset State: <strong>{{ asset.assetstate }}</strong
            ><br />
            Asset Note: <strong>{{ asset.assetnote }}</strong
            ><br />
            Asset Devicename: <strong>{{ asset.devicename }}</strong
            ><br />
          </template>
          <div v-if="editing">
            <GenericEditBox
              :parentID="this.parentID"
              :title="`Assets`"
              :headers="[
                { id: 1, name: `co_description`, default: `` },
                { id: 2, name: `assetstate`, default: `` },
                { id: 3, name: `co_groupcode`, default: `` },
                { id: 4, name: `co_locationid`, default: `` },
                { id: 5, name: `devicename`, default: `` },
                { id: 6, name: `assetnote`, default: `` },
              ]"
              :original="this.asset"
            >
            </GenericEditBox>
          </div>
        </div>
        <div id="location" style="display: inline-block">
          <template v-if="location">
            <h4>Location information</h4>
            Street: <strong>{{ location.addr1 }} {{ location.addr2 }}</strong><br/>
            City: <strong>{{ location.addr3  }}</strong><br/>
            Country: <strong>{{ location.addr4 }}</strong><br/>
            Postcode: <strong>{{ location.addr5 }}</strong><br/>
            Eastings: <strong>{{ location.eastings }}</strong><br/>
            Northings: <strong>{{ location.northings }}</strong><br/>
          </template>
          <div v-if="editing">
            <GenericEditBox
              :parentID="this.parentID"
              :title="`Location`"
              :headers="[
                { id: 0, name: `Eastings`, default: `` },
                { id: 1, name: `Northings`, default: `` },
                { id: 2, name: `loc_lat`, default: `` },
                { id: 3, name: `loc_lon`, default: `` },
                { id: 4, name: `addr1`, default: `` },
                { id: 5, name: `addr2`, default: `` },
                { id: 6, name: `addr3`, default: `` },
                { id: 7, name: `addr4`, default: `` },
                { id: 8, name: `addr5`, default: `` },
              ]"
              :original="this.location"
            >
            </GenericEditBox>
          </div>
        </div>
        <div id="group" style="display: inline-block">
          <template v-if="groupinfo">
            <h4>Group information</h4>
            Group code: <strong>{{ groupinfo.co_groupcode }}</strong
            ><br />
            Group name: <strong>{{ groupinfo.co_groupname }}</strong
            ><br />
            Group description: <strong>{{ groupinfo.co_groupdesc }}</strong
            ><br />
          </template>
          <div v-if="editing">
            <GenericEditBox
              :parentID="this.parentID"
              :title="`Group`"
              :headers="[
                { id: 1, name: `co_groupname`, default: `` },
                { id: 2, name: `co_groupdesc`, default: `` },
              ]"
              :original="this.groupinfo"
            >
            </GenericEditBox>
          </div>
        </div>
        <div id="physical" style="display: inline-block">
          <template v-if="physicalinfo">
            <h4>Physical information</h4>
            Smart Device ID: <strong>{{ physicalinfo.smartdeviceid }}</strong
            ><br />
            Serial Number: <strong>{{ physicalinfo.serialnum }}</strong
            ><br />
            Physical Type: <strong>{{ physicalinfo.physicaltype }}</strong
            ><br />
            Device Name: <strong>{{ physicalinfo.devicename }}</strong
            ><br />
          </template>
          <div v-if="editing">
            <GenericEditBox
              :parentID="this.parentID"
              :title="`Physical`"
              :headers="[
                { id: 0, name: `smartdeviceid`, default: `` },
                { id: 1, name: `serialnum`, default: `` },
                { id: 2, name: `physicaltpye`, default: `` },
                { id: 3, name: `devicename`, default: ``}
              ]"
              :original="this.physicalinfo"
            >
            </GenericEditBox>
          </div>
        </div>
      </div>
      <div style="clear: both; overflow-y: scroll">
        <GenericListTable
          :parentID="this.parentID"
          :title="`Assets`"
          :headers="[
            { text: 'ID', value: 'id' },
            { text: 'Asset Id', value: 'co_assetid' },
            { text: 'Description', value: 'co_description' },
            { text: 'Asset State', value: 'assetstate' },
            { text: 'Asset Note', value: 'assetnote' },
            { text: 'Group code', value: 'co_groupcode' },
            { text: 'Device Name', value: 'devicename' },
            { text: 'Location ID', value: 'co_locationid' },
          ]"
          :url="`/manifest/assetinfo`"
          :apiResponseField="`assetinfolist`"
          :onClickRoute="`AssetSingle`"
          :onClickParams="getOnClickParams"
          :editable="true"
          :saveUrl="`manifest/assetinfo/bulk?ids_to_update=`"
        >
        </GenericListTable>
      </div>
    </v-container>
  </v-content>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'
import GenericEditBox from '@/components/Common/GenericEditBox'
export default {
  name: 'AssetSingle',
  components: { GenericListTable, GenericEditBox },
  data () {
    return {
      error: false,
      id: undefined,
      parentID: undefined,
      asset: undefined,
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Asset ID', value: 'co_assetid' },
        { text: 'location ID', value: 'co_locationid' },
        { text: 'Groupcode', value: 'co_groupcode' }
      ],
      assets: [],
      editing: false,
      location: undefined,
      groupinfo: undefined,
      physicalinfo: undefined
    }
  },
  beforeMount () {
    if (this.$route.query.parentid) {
      this.parentID = this.$route.query.parentid
    }
    this.loadAssets()
  },
  async beforeRouteUpdate (to, from, next) {
    next()
    await this.loadAssets()
  },
  methods: {
    async loadAssets () {
      this.id = this.$route.params.id
      if (this.id) {
        try {
          this.$http
            .get(`/manifest/assetinfo?serial_number=${this.id}`)
            .then((request) => this.buildSingleEntry(request.data))
            .catch(() => this.failedReconcileNames())
        } catch (error) {
          this.errorHandler('Asset ID not found.')
        }
      }
    },
    buildSingleEntry (data) {
      this.asset = data.assetinfo
      this.location = data.location
      this.groupinfo = data.group_info
      const smartid = `JF_${data.assetinfo.co_assetid}`.slice(0, -3)
      this.$http
        .get(`/manifest/physicalinfo?smartdeviceid=${smartid}`)
        .then((request) => this.buildPhysical(request.data))
        .catch(() => this.failedReconcileNames())
    },
    buildPhysical (data) {
      this.physicalinfo = data.physicalinfo
    },
    errorHandler (error) {
      this.error = error
    },
    failedReconcileNames () {
      this.errorHandler('Failed to request Refresh of Names.')
    },
    showModal () {
      this.editing = true
    },
    async saveEdit (
      asset,
      newid,
      newdesc,
      newstate,
      newnnote,
      newGroupCode,
      newDevicename,
      newLocationid
    ) {
      // TODO make sure when leaving a field blank everything is cool
      if (newid === null) {
        newid = asset.co_assetid
      }
      if (newdesc === null) {
        newdesc = asset.co_description
      }
      if (newstate === null) {
        newstate = asset.assetstate
      }
      if (newnnote === null) {
        newnnote = asset.assetnote
      }
      if (newGroupCode === null) {
        newGroupCode = asset.co_groupcode
      }
      if (newLocationid === null) {
        newLocationid = asset.co_locationid
      }
      if (newDevicename === null) {
        newDevicename = asset.devicename
      }

      const response = await this.$http.post(
        `manifest/assetinfo/bulk?ids_to_update=[${asset.id}]`,
        {
          assetinfo_arr: [
            {
              co_assetid: newid,
              co_description: newdesc,
              assetstate: newstate,
              co_groupcode: newGroupCode,
              devicename: newDevicename,
              co_locationid: newLocationid,
              assetnote: newnnote
            }
          ],
          co_groupcode_arr: [newGroupCode]
        }
      )
      window.alert(response.data.message)
      this.editing = false
    },
    getOnClickParams (item) {
      this.id = item.co_assetid

      return {
        id: item.co_assetid,
        assets: []
      }
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
